import { inject, Injectable } from '@angular/core';
import { Actions, act, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { PaymentAPIService } from '../api/payment-api.service';
import { of } from 'rxjs';
import { invokeInvoiceResponse, invokePayment, invokePaymentSession, paymentFailure, paymentSuccess, setInvoiceResponse, setPaymentSession } from './payment.action';

@Injectable()
export class PaymentEffects {
  private actions$ = inject(Actions);
  private paymentService = inject(PaymentAPIService);

  loadFrpData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(invokeInvoiceResponse),
      switchMap((action) => {
        return this.paymentService.getInvoiceResponse(action.encodedString).pipe(
          map(invoiceResponse => setInvoiceResponse({ invoiceResponse })),
          catchError(errorMessage => of(paymentFailure({ errorMessage: errorMessage })))
        );
      })
    )
  }
  )

  invokePaymentSession$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(invokePaymentSession),
      switchMap((action) => {
        return this.paymentService.getPaymentSession(action.encodedString).pipe(
          map(paymentSession => setPaymentSession({ paymentSession })),
          catchError(errorMessage => of(paymentFailure({ errorMessage: errorMessage })))
        );
      })
    )
  }
  )

  invokePayment$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(invokePayment),
      switchMap(({ paymentRequestModel }) => {
        return this.paymentService.makePayment(paymentRequestModel).pipe(
          map(paymentResponse => paymentSuccess({ paymentResponse })),
          catchError(errorMessage => of(paymentFailure({ errorMessage: errorMessage })))
        );
      })
    )
  }
  )
}